'use strict';

const trackingUtils = require('../tracking.utils');
const flowCache = require('./flow.cache');

const LOAD_LABEL = 'last_chance_onload';
const CLICKS_LABEL = 'last_chance_clicks';

const sendTrack = (action = '', label = []) => {
    trackingUtils.trackEvent(action, label.join('_'));
};

const getQueueInfo = (info) => ({
    oldLength: flowCache.getQueue(info.flow).length,
    queue: flowCache.enqueue(info),
});

const doSendAppearancesTracking = (info) => {
    const {oldLength, queue} = getQueueInfo(info);

    if (oldLength !== queue.length) {
        sendTrack(LOAD_LABEL, queue);
    }
};

module.exports = {
    sendAppearancesTracking(info) {
        doSendAppearancesTracking(info);
    },

    sendAppearancesTrackingAtPageLoad(pageData, info) {
        if (pageData.current === info.id) {
            doSendAppearancesTracking(info);
        }
    },

    sendEventTrack(flow) {
        sendTrack(CLICKS_LABEL, flowCache.getQueue(flow));
    },

    getTrackingPageFlowAppearancesInfo(widget = {}) {
        return widget.trackingPageFlowAppearancesSettings || {
            flow: `${widget.name}_flow`,
            label: `${widget.name}:ap`,
        };
    },
};
